import { textPalette, greenPrimary } from './colors'

const textfieldOverride = {
  MuiTextField: {
    root: {
      '& label.Mui-focused': {
        color: greenPrimary,
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: greenPrimary,
        },
      },
      minHeight: '78px',
      '& .MuiOutlinedInput-adornedEnd': {
        minHeight: 'unset',
        paddingRight: 0,
      },
      '& label': {
        color: textPalette.disabled,
      },
      '& .MuiInputAdornment-positionEnd': {
        marginRight: '16px',
      },
    },
  },
}

export default textfieldOverride
